import { Formik } from 'formik'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import InputEmail from '../../Inputs/InputEmail/InputEmail'
import InputPhone from '../../Inputs/InputPhone/InputPhone'
import InputText from '../../Inputs/InputText/InputText'
import Typography from '../../Typography/Typography'
import InfoWindow from '../../Windows/InfoWindow/InfoWindow'
import FormAgreements from '../FormAgreements/FormAgreements'
import FormInputsContainer from '../FormInputsContainer/FormInputsContainer'
import FormLayout from '../FormLayout/FormLayout'

import hocFormContactInfo from './hocFormContactInfo'

import './FormContactInfo.scss'
import LoadImage from './LoadImage/LoadImage'

const FormContactInfo = ({
    contactInfo,
    gdprAgreements,
    loading,
    firstname,
    lastname,
    phone,
    email,
    sectionRef,
    isPersonalGDPR,
    isNonPersonalGDPR,
}) => {
    const intl = useIntl()

    const initialValues = {
        firstname,
        lastname,
        phone,
        email,
    }

    const validationSchema = Yup.object({
        firstname: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
        lastname: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
        phone: Yup.string()
            .matches(/^[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/, intl.formatMessage({ id: 'forms.register.phoneError' }))
            .required(intl.formatMessage({ id: 'forms.required' })),
        email: Yup.string()
            .email(intl.formatMessage({ id: 'forms.register.emailError' }))
            .required(intl.formatMessage({ id: 'forms.required' })),
    })

    if (!email && !firstname && !lastname && !phone) {
        return (
            <InfoWindow
                color={'transparent'}
                title={intl.formatMessage({ id: 'windows.loading.title' })}
                description={intl.formatMessage({ id: 'windows.loading.wait' })}
            />
        )
    }

    return (
        <Container fluid className="contact-info d-flex flex-column" ref={sectionRef}>
            <Typography variant={'h2'}>{intl.formatMessage({ id: 'forms.contactInfo.title' })}</Typography>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => contactInfo(values)}
            >
                {(formik) => (
                    <FormLayout
                        size={'lg'}
                        onSubmit={formik.handleSubmit}
                        className={`contact-info--form d-flex flex-column`}
                    >
                        <FormInputsContainer>
                            <InputText
                                name={'firstname'}
                                id={'firstname'}
                                error={formik?.errors?.firstname}
                                touched={formik?.touched?.firstname}
                                {...formik.getFieldProps('firstname')}
                                label={intl.formatMessage({ id: 'forms.register.nameLabel' })}
                                placeholder={intl.formatMessage({ id: 'forms.register.namePlaceholder' })}
                                onBlur={formik?.handleBlur}
                            />

                            <InputText
                                name={'lastname'}
                                id={'lastname'}
                                error={formik?.errors?.lastname}
                                touched={formik?.touched?.lastname}
                                {...formik.getFieldProps('lastname')}
                                label={intl.formatMessage({ id: 'forms.register.surnameLabel' })}
                                placeholder={intl.formatMessage({ id: 'forms.register.surnamePlaceholder' })}
                                onBlur={formik?.handleBlur}
                            />
                        </FormInputsContainer>
                        <FormInputsContainer>
                            <InputPhone
                                name={'phone'}
                                id={'phone'}
                                data-test="contactInfoNumber"
                                error={formik?.errors?.phone}
                                touched={formik?.touched?.phone}
                                {...formik.getFieldProps('phone')}
                                label={intl.formatMessage({ id: 'forms.register.phoneLabel' })}
                                placeholder={intl.formatMessage({ id: 'forms.register.phonePlaceholder' })}
                                onBlur={formik?.handleBlur}
                            />
                            <InputEmail
                                name={'email'}
                                id={'email'}
                                error={formik?.errors?.email}
                                touched={formik?.touched?.email}
                                {...formik.getFieldProps('email')}
                                label={intl.formatMessage({ id: 'forms.register.emailLabel' })}
                                placeholder={intl.formatMessage({ id: 'forms.register.emailPlaceholder' })}
                                onBlur={formik?.handleBlur}
                            />
                        </FormInputsContainer>

                        <FormInputsContainer>
                            <LoadImage />
                        </FormInputsContainer>

                        <Container fluid>
                            <ButtonCinestar
                                data-test="contactInfoSubmit"
                                variant={'primary-v1'}
                                type={'submit'}
                                disabled={loading}
                            >
                                {intl.formatMessage({
                                    id: 'buttons.buttonSave',
                                })}
                            </ButtonCinestar>
                        </Container>
                    </FormLayout>
                )}
            </Formik>

            <FormAgreements
                loading={loading}
                isPersonalGDPR={isPersonalGDPR}
                isNonPersonalGDPR={isNonPersonalGDPR}
                handleSubmit={(values) => gdprAgreements(values)}
            />
        </Container>
    )
}

export default hocFormContactInfo(FormContactInfo)
